import React, {useEffect, useState} from "react";
import {getUrl} from "src/service/files.service";
import {checkEmpty} from "src/utils/janus.utils";

const LazyImage = ({
  imageDetails,
  handleClick,
  src,
  id,
  isNewImage,
  localImage
}: any) => {
  const fileServiceDownloadURL =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";

  const [isShowPreview, setShowPreview] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isPreview, setIsPreview] = useState(null);
  const [urlFile, setUrlFile] = useState("");

  const onError = (event: any) => {
    if (!checkEmpty(urlFile)) {
      setIsError(true);
      event.target.classList.add("has-error");
    }
  };
  const onLoad = (event: any) => {
    if (!checkEmpty(urlFile)) {
      event.target.classList.add("loaded");
      setShowPreview(false);
    }
  };

  useEffect(() => {
    try {
      let isPreviewT = isNewImage
        ? URL.createObjectURL(src) 
        : localImage
        ? URL.createObjectURL(localImage)
        : src;
      setIsPreview(isPreviewT);
    } catch (e) {
      console.log(e);
    }
    
    
  }, []);

  useEffect(() => {
    checkGetUrlFile();
  }, []);
  
  const checkGetUrlFile = async () => {
    let url: any = fileServiceDownloadURL + imageDetails?.id + "&size=300";
    url = await getUrl(url, imageDetails?.id, 300, "post");
    setUrlFile(url);
  };

  return (
    <>
      {isShowPreview && (
        <img
          style={
            isShowPreview
              ? { display: "block", background: "transparent" }
              : { display: "none" }
          }
          id={id}
          //@ts-ignore
          src={isPreview}
          alt=""
          onClick={isError ? undefined : handleClick}
          className="preview aaa"
        />
      )}
      {imageDetails?.id && (
        <img
          id={id}
          style={
            !isShowPreview
              ? { display: "block", background: "transparent" }
              : { display: "none" }
          }
          src={urlFile}
          alt=""
          onClick={isError ? undefined : handleClick}
          onLoad={onLoad}
          onError={onError}
          className="preview"
        />
      )}
    </>
  );
};
export default React.memo(LazyImage);
